<template>
    <!--Navbar Open Start-->
  <div id="navbarOpen" class="position-fixed container-fluid vh-100 vw-100 bg-open-menu z-open-menu p-0 overflow-auto">
    <div :class="{'container': !isLandingPage, 'max-w-1520 mx-auto px-3 px-lg-5': isLandingPage}">
      <nav class="navbar navbar-dark" :class="{'mt-4': !isLandingPage, 'mt-3 mt-lg-4': isLandingPage}">
        <!--Navbar First Line-->
        <div class="container-fluid d-flex align-items-center" :class="{'p-0': isLandingPage}">
          <a class="navbar-brand" href="/">
            <img src="../../assets/media/logo.png" alt="Logo" width="62" height="62">
          </a>
          <div id="navbarSupportedContent">
            <ul class="navbar-nav d-flex flex-row w-100 align-items-center" :class="{'mb-2 mb-lg-0': !isLandingPage}">
              <li @click="closeNavbar" class="nav-item ms-4">
                <a class="btn nav-link text-white border rounded rounded-circle p-4 d-flex align-items-center size-nav-btn b-white">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30">
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                      d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
                      fill="rgba(255,255,255,1)" />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div id="desktop-nav" class="row">
        <!--Navbar Content Start-->

        <div class="w-xl-content d-flex flex-column gap-4 mt-3 mb-3 mb-lg-0 scrollable-narrow text-uppercase px-4">
          <div class="overflow-hidden">
            <a href="https://komitenti.lion-group.rs/#!/login" class="d-flex align-items-center text-light slideUpText">
              <h1 class="link-text mb-0 navtext-size">Komitenti</h1>
            </a>
          </div>
          <div class="overflow-hidden">
            <a href="/kontakt-informacije" class="d-flex align-items-center text-light ps-20 slideUpText">
              <h1 :class="path == '/kontakt-informacije' ? 'text-second' : ''" class="link-text mb-0 navtext-size">Kontakt</h1>
            </a>
          </div>
          <div class="overflow-hidden">
            <a href="/zastita-podataka" class="d-flex align-items-center text-light slideUpText">
              <h1 :class="(path == '/zastita-podataka') ? 'text-second' : ''" class="link-text mb-0 navtext-size">Zaštita podataka</h1>
            </a>
          </div>
          <div class="overflow-hidden">
            <a href="/pravila-i-uslovi-koriscenja" class="d-flex align-items-center text-light ps-20 slideUpText">
              <h1 :class="path == '/pravila-i-uslovi-koriscenja' ? 'text-second' : ''" class="link-text mb-0 navtext-size">Pravila i uslovi korišćenja</h1>
            </a>
          </div>
          <div class="overflow-hidden">
            <a href="/otvorene-pozicije" class="d-flex align-items-center text-light slideUpText">
              <h1 :class="path == '/otvorene-pozicije' ? 'text-second' : ''" class="link-text mb-0 navtext-size">Karijera</h1>
            </a>
          </div>
        </div>
      </div>


      <!-- Nav bar on mobile -->
      <div id="mobile-nav" class="row d-none">
        <div class="w-xl-content d-flex flex-column gap-4 mt-3 mb-3 mb-lg-0 scrollable-narrow text-uppercase px-4">
          <div class="overflow-hidden">
            <a href="/benzinske-stanice" class="d-flex align-items-center text-light ps-20 slideUpText">
              <h1 :class="path == '/benzinske-stanice' ? 'text-second' : ''" class="link-text mb-0 navtext-size">Lokacije</h1>
            </a>
          </div>
          <div class="overflow-hidden">
            <a href="/euro-petrol-klub" class="d-flex align-items-center text-light slideUpText">
              <h1 :class="path == '/euro-petrol-klub' ? 'text-second' : ''" class="link-text mb-0 navtext-size">Euro Petrol Klub</h1>
            </a>
          </div>
          <div class="overflow-hidden">
            <a href="/euro-petrol-aplikacija" class="d-flex align-items-center text-light ps-20 slideUpText">
              <h1 :class="path == '/euro-petrol-aplikacija' ? 'text-second' : ''" class="link-text mb-0 navtext-size">Euro Petrol Aplikacija</h1>
            </a>
          </div>
          <div class="overflow-hidden">
            <a href="/lion-expert/proizvodi" class="d-flex align-items-center text-light slideUpText">
              <h1 :class="(path == '/lion-expert/proizvodi') ? 'text-second' : ''" class="link-text mb-0 navtext-size">Proizvodi</h1>
            </a>
          </div>
          <div class="overflow-hidden">
            <a href="/usluge" class="d-flex align-items-center text-light ps-20 slideUpText">
              <h1 :class="path == '/usluge' ? 'text-second' : ''" class="link-text mb-0 navtext-size">Usluge</h1>
            </a>
          </div>
          <div class="overflow-hidden">
            <a href="/otvorene-pozicije" class="d-flex align-items-center text-light slideUpText">
              <h1 :class="path == '/otvorene-pozicije' ? 'text-second' : ''" class="link-text mb-0 navtext-size">Karijera</h1>
            </a>
          </div>
        </div>
        <!--Navbar Content End-->
        <div class="container d-flex flex-column align-items-end justify-content-end px-4 overflow-hidden pb-4">
          <a href="https://komitenti.lion-group.rs/#!/login" rel="noopener" target="_blank" class="mb-0 text-second text-uppercase slideUpText yellow-text-size"><h4>Komitenti</h4></a>
          <div class="d-flex slideUpText flex-wrap justify-content-end">
            <a href="/kontakt-informacije"><small class="mb-0 text-light text-right navnum-size p-2 menu-link">Kontakt</small></a>
            <a href="/zastita-podataka"><small class="mb-0 text-light text-right navnum-size p-2 menu-link">Zaštita podataka</small></a>
            <a href="/pravila-i-uslovi-koriscenja"><small class="mb-0 text-light text-right navnum-size p-2 menu-link">Pravila i uslovi korišćenja</small></a>
          </div>
        </div>

      </div>

      <!-- Nav bar on mobile end -->

    </div>
  </div>
  <!--Navbar Open End-->
</template>

<script>
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

export default {
  setup() {
    const store = useStore();
    function closeNavbar() {
      store.dispatch('closeMenu');
    };

    const route = useRoute();

    const path = route.path;
    const isLandingPage = path === '/mobile-app';

    function setNav() {
      var mob = false;
      if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(navigator.userAgent)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent))
        mob = true;

      var desktopNav = document.getElementById('desktop-nav');
      var mobileNav = document.getElementById('mobile-nav');

      if (mob) {
        desktopNav.classList.add('d-none');
        mobileNav.classList.remove('d-none');
      } else {
        desktopNav.classList.remove('d-none');
        mobileNav.classList.add('d-none');
      }
    };

    return {
      closeNavbar,
      path,
      isLandingPage,
      setNav
    }
  },
  mounted() {
    this.setNav()
  }
}
</script>

<style scoped>
@import '../../assets/variables.css';

.z-1000 {
  z-index: 1000;
}

.max-w-1520 {
  max-width: 1520px;
}

.z-open-menu {
  z-index: 9999;
}

a{
  text-decoration: none;
}

.fadeIn{
  cursor: pointer;
}

h1:hover, .menu-link:hover{
  color: var(--color-secondary) !important;
}

.fadeIn{
  -webkit-animation: fadeInUp 500ms ease-in-out; /* Chrome, Safari, Opera */
  animation: fadeInUp 500ms ease-in-out;
}

.w-lg-content {
  width: fit-content;
}

.navtext-size {
  font-size: 7.3vh;
}

.navnum-size {
  font-size: 1.8vh;
}

.size-nav-btn:hover{
  border: 1px solid #f8f9fa !important;
}

.yellow-text-size {
  font-size: 2.5vh;
}

.ps-20 {
  padding-left: calc(2vw + 10vh);
}

.me-num {
  margin-right: calc(0.75vw + 2.5vh);
}

@media (max-width: 576px) {
  .bottom-negative-10 {
    bottom: -30%;
  }

  .navtext-size {
    font-size: 4.5vh !important;
  }

  .navnum-size {
    font-size: 2vh;
  }

  .yellow-text-size {
    font-size: 3vh;
  }
}

@media (max-width: 768px) {
  .navtext-size {
    font-size: 5.3vh;
  }
}

@media (max-width: 1200px) {
  .w-xl-content {
    width: 100%;
  }
}
</style>
